var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('post-view',{staticClass:"page-view",class:[this.$route.name],attrs:{"post":_vm.postData}})}
var staticRenderFns = []

export { render, staticRenderFns }